import React from "react";
import { Row, Col, Button } from "antd";

import "./index.css";

const handleOnRefreshPage = () => {
  window.location.reload();
};

const ErrorPage = props => {
  return (
    <Row
      type="flex"
      justify="space-around"
      align="middle"
      style={{ minHeight: 420, height: "100vh" }}
    >
      <Col
        span={20}
        className="error-container"
        style={{ textAlign: "center" }}
      >
        <div className="error-icon">
          <img alt="maintenance" src="/images/maintenance.png" />
        </div>
        <div className="error-title">Something went wrong</div>

        <div className="error-description">
          {props &&
          props.error &&
          props.error.message === "Error fetching data from sap"
            ? props.error.message
            : "There is a problem with the server"}
        </div>
        <Row type="flex" justify="center">
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 11 }}
            lg={{ span: 11 }}
          >
            <div className="error-button">
              <Button
                style={{ marginTop: 20 }}
                type="primary"
                className="error-btn"
                onClick={handleOnRefreshPage}
              >
                Refresh Page
              </Button>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ErrorPage;
